<template>
  <v-sheet  class="pa-2" style="z-index: 1 !important;" >
<!--      <v-row no-gutters>-->
<!--        <v-col cols="6">-->
          <div style="font-weight: bold; font-size: 0.8rem">Cancer Type</div>
          <div v-for="(item) in cancer_type" :style="{fontSize:item.size}">
            <v-icon :size="item.size" :color="item.color" >{{item.type}}</v-icon> {{item.label}}
          </div>
          <div style="font-weight: bold; font-size: 0.8rem">Phenotype</div>
          <div v-for="(item) in phenotype" :style="{fontSize:item.size}">
            <v-icon :size="item.size" color="black" >{{item.type}}</v-icon> {{item.label}}
          </div>

          <div style="font-weight: bold; font-size: 0.8rem">Significance</div>
          <div v-for="(item) in significant" :style="{fontSize:item.size}">
            <v-icon :size="item.size" color="black" >{{item.type}}</v-icon> <a style="color: black; font-size: 0.8rem" >{{item.label}}</a>
          </div>

  </v-sheet>
</template>

<script>
export default {
  name: "phenotype_legend",
  props: [],
  components: {},
  data() {
    return {
      size:"0.7rem",
      significant:[
        {type: "mdi-rhombus-outline", label: "  NS.",size:"0.6rem"},
        {type: "mdi-rhombus-outline", label: "Significant",size:"0.8rem"}
      ],
      phenotype:[
        {type: "mdi-hospital", label: "clinical",size:"0.8rem"},
        {type: "mdi-square", label: "pathway",size:"0.8rem"},
        {type: "mdi-triangle", label: "cell type",size:"0.8rem"},  // 这里需要自定义 triangle, 可以加一个自定义 triangle 的 svg
        {type: "mdi-circle", label: "mutation",size:"0.8rem"},
        {type: "mdi-axis mdi-rotate-180 m", label: "genomics",size:"0.8rem"},
      ],
      cancer_type: [
        // 颜色相关的条目
        {type: "mdi-circle", label: "BRCA", color: "#fd8cd5",size:"0.8rem"},
        {type: "mdi-circle", label: "CCRCC", color: "#ed7711",size:"0.8rem"},
        {type: "mdi-circle", label: "COAD", color: "#0728e4",size:"0.8rem"},
        {type: "mdi-circle", label: "GBM", color: "#62666b",size:"0.8rem"},
        {type: "mdi-circle", label: "HNSCC", color: "#89263b",size:"0.8rem"},
        {type: "mdi-circle", label: "LSCC", color: "#cb4763",size:"0.8rem"},
        {type: "mdi-circle", label: "LUAD", color: "#d3d3d3",size:"0.8rem"},
        {type: "mdi-circle", label: "OV", color: "#107d9d",size:"0.8rem"},
        {type: "mdi-circle", label: "PDAC", color: "#b80ec4",size:"0.8rem"},
        {type: "mdi-circle", label: "UCEC", color: "#f04688",size:"0.8rem"}
      ]
    }
  },
  methods: {},
  mounted() {

  }
}
</script>

<style type="text/scss" lang="scss" scoped>

</style>